import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=251142fe&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=251142fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251142fe",
  null
  
)

export default component.exports